export class RegexHelper {
    public static validateTime(str: string){
        let reg = /([0-1]?\d|2[0-3]):[0-5]\d/g;
        return reg.test(str);
    }
}